export const gameImportType = {
  IMAGE: 'IMAGE',
  SPRITESHEET: 'SPRITESHEET',
  AUDIO: 'AUDIO',
};
